import React, { PropsWithChildren, useState, useEffect } from 'react';
import PractitionerProvider from '../Practitioner';
import { authContext } from '../../../config/adal';

const UserProvider = ({ children }: PropsWithChildren<{}>) => {
  const [practitionerEmail, setPractitionerEmail] = useState<
    string | undefined
  >(undefined);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    try {
      setLoading(true);
      authContext.getUser((error, user) => {
        if (!error && user) setPractitionerEmail(user.userName);
        setLoading(false);
      });
    } catch {
      setLoading(false);
    }
  }, []);
  return (
    <PractitionerProvider practitionerEmail={practitionerEmail}>
      {!loading ? children : null}
    </PractitionerProvider>
  );
};

export default UserProvider;
